import Shader from '../../shader'
import {simpleShader} from '../../util'
import * as store from '../../store'

/**
 * @filter        Color Halftone
 * @description   Simulates a CMYK halftone rendering of the image by multiplying pixel values
 *                with a four rotated 2D sine wave patterns, one each for cyan, magenta, yellow,
 *                and black.
 * @param centerX The x coordinate of the pattern origin.
 * @param centerY The y coordinate of the pattern origin.
 * @param angle   The rotation of the pattern in radians.
 * @param size    The diameter of a dot in pixels.
 */
export default function(centerX, centerY, angle, size) {
  var gl = store.get('gl')
  gl.colorHalftone = gl.colorHalftone || new Shader(null, '\
    uniform sampler2D texture;\
    uniform vec2 center;\
    uniform float angle;\
    uniform float scale;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    float pattern(float angle) {\
      float s = sin(angle), c = cos(angle);\
      vec2 tex = texCoord * texSize - center;\
      vec2 point = vec2(\
        c * tex.x - s * tex.y,\
        s * tex.x + c * tex.y\
      ) * scale;\
      return (sin(point.x) * sin(point.y)) * 4.0;\
    }\
    \
    void main() {\
      vec4 color = texture2D(texture, texCoord);\
      vec3 cmy = 1.0 - color.rgb;\
      float k = min(cmy.x, min(cmy.y, cmy.z));\
      cmy = (cmy - k) / (1.0 - k);\
      cmy = clamp(cmy * 10.0 - 3.0 + vec3(pattern(angle + 0.26179), pattern(angle + 1.30899), pattern(angle)), 0.0, 1.0);\
      k = clamp(k * 10.0 - 5.0 + pattern(angle + 0.78539), 0.0, 1.0);\
      gl_FragColor = vec4(1.0 - cmy - k, color.a);\
    }\
  ');

  simpleShader.call(this, gl.colorHalftone, {
    center: [centerX, centerY],
    angle: angle,
    scale: Math.PI / size,
    texSize: [this.width, this.height]
  });

  return this;
}



// WEBPACK FOOTER //
// ./src/filters/fun/colorhalftone.js